import auth from '@/Data/Functions/auth';

export default {
    upload () {
        if (!window.Appcues) {
            return;
        }

        const userinfo = auth.userinfo().userinfo;

        if (!userinfo || userinfo.securityLevelName === 'NOT LOGGED IN' || !userinfo.uid) {
            window.Appcues.reset();
            return;
        }

        window.Appcues.identify(
            userinfo.uid.toString(),
            this.mapUserInfo(userinfo));

        window.Appcues.group(
            `${userinfo.groupId}-${userinfo.homeStoreClientRef}`,
            this.mapGroupInfo(userinfo));
    },
    mapUserInfo (userinfo) {
        return {
            cashierId: userinfo.uid,
            cashierName: userinfo.name,
            securityLevel: userinfo.securityLevel,
            environment: userinfo.environment,
            cloudPosArea: 'Cloud Merchant Tools'
        };
    },
    mapGroupInfo (userinfo) {
        return {
            homeStoreClientRef: userinfo.homeStoreClientRef,
            groupId: userinfo.groupId
        };
    }
}
